export { default as default } from './LogoDirecte';
